<template>
  <div v-if="blogElement" class="blog-detail">
    <div class="container">
      <DefBreadCrumbs :result="getBreadCrumbs" />
      <div class="blog-detail-header">
        <div class="blog-active">
          <BlogLabels />
          <span class="blog-active__time">
            {{ blogElement.activeFrom }}
          </span>
        </div>
        <DefTitle :result="1">
          <h1>{{ blogElement.name }}</h1>
        </DefTitle>

        <DefAiButtons :items="aiButtons.items" :title="aiButtons.messages.blogTitle" />

        <BlogSocial />
      </div>
    </div>

    <DefInsertTilda v-if="blogElement" :result="blogElement.detailText" />

    <div class="container">
      <div class="blog-detail-bottom">
        <BlogLabels />
        <BlogDetailShare />
      </div>
    </div>
    <DefSlideModal :active="isOpenKits" @close="isOpenKits = false">
      <template #title>
        {{ kits.title }}
      </template>
      <BlogKits :result="kits.items" />
    </DefSlideModal>

    <div class="container">
      <BlogSimilar />
    </div>
  </div>
</template>

<script lang="ts" setup>
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefSlideModal from '@components/Def/DefSlideModal/DefSlideModal.vue';
import DefInsertTilda from '@components/Def/DefInsertTilda/DefInsertTilda.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { storeToRefs } from 'pinia';
import { ref, computed, onMounted } from 'vue';
import BlogSocial from '@components/Blog/BlogSocial/BlogSocial.vue';
import BlogSimilar from '@components/Blog/BlogSimilar/BlogSimilar.vue';
import BlogLabels from '@components/Blog/BlogLabels/BlogLabels.vue';
import BlogKits from '@components/Blog/BlogKits/BlogKits.vue';
import BlogDetailShare from '@components/Blog/BlogDetail/BlogDetailShare.vue';
import DefAiButtons from '@components/Def/DefAi/DefAiButtons.vue';

const activeKitsId = ref(undefined);
const isOpenKits = ref(false);

const { blogElement, breadcrumbs } = storeToRefs(useResultsStore());

const kits = computed(() => blogElement.value?.kits[activeKitsId.value]?.displayProperties?.ITEMS);
const getBreadCrumbs = computed(() => breadcrumbs.value.slice(2));
const aiButtons = computed(() => blogElement.value?.aiButtons);

const handlerShowKits = (e) => {
  e.preventDefault();
  activeKitsId.value = e.currentTarget.getAttribute('data-complect-ids');
  isOpenKits.value = true;
};
const initKits = () => {
  const elements = document.querySelectorAll('[data-complect-ids]');
  elements.forEach((el) => el.addEventListener('click', handlerShowKits));
};

onMounted(() => {
  initKits();
});
</script>

<style lang="scss" scoped>
.blog-detail {
  margin-bottom: 64px;
  @include point-lg {
    margin-bottom: 80px;
  }
  :deep(.def-title) {
    margin-bottom: 16px;
  }
  :deep(.blog-similar) {
    margin-top: 64px;
    @include point-lg {
      margin-top: 80px;
    }
  }
  :deep(.def-slide-modal__block) {
    background-color: #f6f6f6;
    //z-index: 1001;
    width: 320px;
    padding: 40px 6px 0 16px;
    @include point-md {
      width: 524px;
      padding: 32px 14px 0 24px;
    }
    @include point-lg {
      width: 600px;
      padding: 40px 50px 0 60px;
    }
  }
  :deep(.def-slide-modal__close) {
    top: 8px;
    right: 8px;
    @include point-md {
      top: 16px;
      right: 16px;
    }
    @include point-lg {
      top: 32px;
      right: 40px;
    }
  }
  :deep(.def-slide-modal__title) {
    font-weight: 600;
    font-size: rem(18);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 33px;
    }
    @include point-lg {
      margin-bottom: 31px;
    }
  }
}
.blog-active {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
  &__time {
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    color: #5f5f67;
    margin-left: 13px;
  }
}
.blog-detail-header {
  margin-bottom: 20px;
  :deep(.def-ai-buttons) {
    margin-bottom: 16px;
  }
}
.blog-detail-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid #cacece;
  max-width: 851px;
  margin: 48px auto 0;
}
</style>
